<ng-select #vs
  class="relative custom-ng-select border border-[#E3E6EE] rounded shadow-none text-xs leading-6 font-medium text-[#15191E] focus:shadow-none"
  [virtualScroll]="true" [appendTo]="appendToBody ? 'body' : null" (keydown.esc)="$event.preventDefault()"
  (scroll)="scroll($event)" (scrollToEnd)="scrollToEnd()" (search)="onSearch($event.term)" [(ngModel)]="selected"
  [closeOnSelect]="closeOnSelect" [placeholder]="placeHolder" (change)="select($event)" [disabled]="disabled" (blur)="blur()"
  (clear)="onClear()" [clearable]="isClearAble" [multiple]="multiple" [ngClass]="{ 'has-value': isValueSelected }"
  >
  <!--  -->
  <ng-template ng-header-tmp *ngIf="showRefresh" id="virtual-scroll-header">
    <div class="text-right">
      <small (click)="onClear()" class="text-blue-600 cursor-pointer hover:underline">
        Refresh {{ placeHolder }}
      </small>
    </div>
  </ng-template>

  <ng-option *ngIf="allowAll" value="">
    <span class="text-green-600">All {{ placeHolder }}</span>
  </ng-option>
  <ng-option *ngFor="let item of dataBuffer" [value]="getValue(item)">
    <div class="flex items-center gap-2">
    <app-avatar [userList]="[{ displayName: item?.fullName, pic: item?.pic }]" [charLength]="2" size="md"></app-avatar>
    <span class="text-sm leading-6 text-[#141414]">
      {{ item.fullName }}
    </span>
  </div>
  </ng-option>
  <ng-template ng-footer-tmp *ngIf="addNew">
    <div class="text-right">
      <small (click)="onAdd()" class="text-blue-600 cursor-pointer hover:underline">
        New {{ placeHolder }}
      </small>
    </div>
  </ng-template>


</ng-select>
